import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChecklistImage } from '../core/type';
import { ChecklistImageService } from '../core/service';

@Injectable()
export class ChecklistImageApiService implements ChecklistImageService {
  private readonly defaultUrl = `${environment.apiHost}/checklistImages`;

  constructor(private httpClient: HttpClient) {}

  replaceFile(id: number, file: File): Observable<ChecklistImage> {
    const formData = new FormData();
    formData.append('image_url', file);
    return this.httpClient.patch<ChecklistImage>(
      `${this.defaultUrl}/${id}/file`,
      formData,
    );
  }
}
